import React, { useState, useRef, useEffect } from "react";
import cx from "classnames";
import styles from "./customfonts.module.scss";
import { Grid, Form, Container, Button } from "semantic-ui-react";
import { toast } from "react-toastify";
import ConfirmModal from "components/ui/ConfirmModal";
import SaveChanges from "components/ui/Buttons/SaveButton";
import { uploadCustomFont } from "actions/accounts";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

export default function PaperfliteDetails({ account }) {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [disableSave, setDisableSave] = useState(true);

  const dispatch = useDispatch();
  const uploadingCustomFont = useSelector((state) => _.get(state, "accounts.uploadFont", {}));

  const onReset = () => {
    setDisableSave(true);
    setSelectedFile(null);
    setOpen(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  useEffect(() => {
    if (uploadingCustomFont.uploading === false && uploadingCustomFont.success === true) {

      if (uploadingCustomFont.success) {
        const status = uploadingCustomFont?.data?.status;

        if (status === "DUPLICATE") {
          toast.error("Font already added to the account");
        } else if (status === "SUCCESS") {
          toast.success(`Successfully uploaded font for ${account?.name}`);
        } else {
          toast.error("Something went wrong. Please try again.");
        }

        onReset();
      } else if (uploadingCustomFont.error) {
        toast.error(uploadingCustomFont.error);
      }
    }
  }, [uploadingCustomFont]);

  const handleFontUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!["font/ttf", "application/x-font-ttf"].includes(file.type)) {
      toast.error("Invalid file type. Please upload a TTF file.");
      return;
    }

    setSelectedFile(file);
    setDisableSave(false);
  };

  // Handle font upload
  const onSaveChanges = () => {
    if (!selectedFile) {
      toast.error("No file selected");
      return;
    }

    dispatch(uploadCustomFont({ accountId: account.id, file: selectedFile }));
    setOpen(false);
  };

  return (
    <Container className={styles.container}>
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <label className={cx(styles.title)}>Custom Fonts</label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column width={8} className={styles.ssoUpload}>
              <div className={styles.uploadAreaWrapper}>
                {selectedFile ? (
                  <span className="description">{selectedFile.name}</span>
                ) : (
                  <>
                    <i className={cx("upload icon", styles.fileIcon)}></i>
                    <span className="description">Upload Custom Font File</span>
                  </>
                )}
                <label className={styles.fileUpload} >
                  {uploadingCustomFont.uploading ? "Uploading..." : "Upload"}
                </label>
                <input
                  className={styles.fileUploadInput}
                  ref={fileInputRef}
                  type="file"
                  accept=".ttf"
                  disabled={uploadingCustomFont.uploading ? true : false}
                  onChange={handleFontUpload}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>

      <div className={styles.buttonstyles}>
        <SaveChanges
          onClick={() => setOpen(true)}
          disabled={disableSave || uploadingCustomFont.uploading}
        />
        <Button
          className={styles.cancelbutton}
          onClick={onReset}
          disabled={uploadingCustomFont.uploading}
        >
          Reset
        </Button>
      </div>

      <ConfirmModal
        open={open}
        setOpen={setOpen}
        onSave={onSaveChanges}
        onCancel={() => onReset()}
        content={`Are you sure you want to upload this font for ${account?.name}?`}
      />
    </Container>
  );
}
